import React, { useState } from "react";

import Form from "../../../forms/components/Form/Form";
import ThemaModal from "../../../thema/components/ThemaModal";

export default function ArticleMetaDataThemaCodes({ name }) {
	const { watch, setValue } = Form.useFormContext();

	const [themaCodes, mainThemaCode] = watch([name, "mainThemaCode"]);

	const [open, setOpen] = useState(false);

	const clearRemovedMainThemaCode = (codes) => {
		if (mainThemaCode && !codes?.includes(mainThemaCode)) {
			setValue("mainThemaCode", null, { shouldDirty: true });
		}
	};

	return (
		<>
			<Form.Select
				name={name}
				options={themaCodes?.map((code) => ({
					key: code,
					text: code,
					value: code,
				}))}
				renderLabel={({ text, value }) => ({
					content: text,
					color: value === mainThemaCode ? "blue" : undefined,
				})}
				onClick={() => setOpen(true)}
				onChangeOptions={({ value }) => clearRemovedMainThemaCode(value)}
				allowEmpty
				multiple
			/>

			{open && (
				<ThemaModal
					value={themaCodes}
					onClose={({ themaCodes }) => {
						setValue(name, themaCodes, { shouldDirty: true });
						clearRemovedMainThemaCode(themaCodes);
						setOpen(false);
					}}
				/>
			)}
		</>
	);
}
